/* import __COLOCATED_TEMPLATE__ from './offering-url-display.hbs.js'; */
import { buildTask as _buildTask } from "ember-concurrency/async-arrow-runtime";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Component from '@glimmer/component';
import { restartableTask, timeout } from 'ember-concurrency';
import { guidFor } from '@ember/object/internals';
export default class OfferingUrlDisplayComponent extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "copy", _buildTask(() => ({
      context: this,
      generator: function* () {
        yield timeout(1500);
      }
    }), null, "copy", "restartable"));
  }
  get copyButtonId() {
    return `offering-url-display-copy-button-${guidFor(this)}`;
  }
  get copyButtonElement() {
    return document.getElementById(this.copyButtonId);
  }
}